/** Wire format shared with livekit-client (`topic: presentation-annotations`). */

export type AnnotationBase = {
	id: string;
	page: number;
	color: string;
	/** Fraction of the displayed image height. */
	strokeWidth: number;
	authorIdentity?: string;
	createdAt: number;
};

export type RectAnnotation = AnnotationBase & {
	kind: "rect";
	x: number;
	y: number;
	w: number;
	h: number;
};

export type ArrowAnnotation = AnnotationBase & {
	kind: "arrow";
	x1: number;
	y1: number;
	x2: number;
	y2: number;
};

export type TextAnnotation = AnnotationBase & {
	kind: "text";
	x: number;
	y: number;
	text: string;
	size: number;
};

export type PenAnnotation = AnnotationBase & {
	kind: "pen";
	points: number[];
};

export type Annotation =
	| RectAnnotation
	| ArrowAnnotation
	| TextAnnotation
	| PenAnnotation;

export type AnnotationMessage =
	| { type: "add"; annotation: Annotation; presentationId: string }
	| { type: "remove"; id: string; presentationId: string }
	| { type: "clear"; page?: number; presentationId: string }
	| { type: "sync"; annotations: Annotation[]; presentationId: string };

export const PRESENTATION_ANNOTATIONS_TOPIC = "presentation-annotations";
